import _objectSpread from "C:\\Users\\budya\\OneDrive\\Documents\\ELMLAB\\EFM2-RF-Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _classCallCheck from "C:\\Users\\budya\\OneDrive\\Documents\\ELMLAB\\EFM2-RF-Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\budya\\OneDrive\\Documents\\ELMLAB\\EFM2-RF-Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { addGlobalEventProcessor, getCurrentHub } from '@sentry/core';
import { getGlobalObject } from '@sentry/utils';
var global = getGlobalObject();
/** HttpContext integration collects information about HTTP request headers */

var HttpContext = /*#__PURE__*/function () {
  function HttpContext() {
    _classCallCheck(this, HttpContext);

    HttpContext.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */


  _createClass(HttpContext, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = HttpContext.id;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setupOnce",
    value: function setupOnce() {
      addGlobalEventProcessor(function (event) {
        if (getCurrentHub().getIntegration(HttpContext)) {
          // if none of the information we want exists, don't bother
          if (!global.navigator && !global.location && !global.document) {
            return event;
          } // grab as much info as exists and add it to the event


          var url = event.request && event.request.url || global.location && global.location.href;

          var _ref = global.document || {},
              referrer = _ref.referrer;

          var _ref2 = global.navigator || {},
              userAgent = _ref2.userAgent;

          var headers = _objectSpread(_objectSpread(_objectSpread({}, event.request && event.request.headers), referrer && {
            Referer: referrer
          }), userAgent && {
            'User-Agent': userAgent
          });

          var request = _objectSpread(_objectSpread({}, url && {
            url: url
          }), {}, {
            headers: headers
          });

          return _objectSpread(_objectSpread({}, event), {}, {
            request: request
          });
        }

        return event;
      });
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'HttpContext';
    }
  }]);

  return HttpContext;
}();

HttpContext.__initStatic();

export { HttpContext };